/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.LegendItem = function( label, color) {
    var config = expocadfx.config;
    var util = expocadfx.util;
    
    var item = document.createElement( "li");
    var square = document.createElement( "span");
    var text = document.createElement( "span");
    //  add if gradient --> create a background gradient from color to booth base color

    text.setAttribute( "class", "legend-text-color");
    
    square.style.backgroundColor = color;
    if( config.bBoothGradient) {
        square.style.background = util.makeGradientStyle( config.clrBoothBase, color, "135");
    }
    square.style.color = color;
    square.innerHTML = "__";
    item.appendChild( square);
    
    text.textContent = label;
    text.style.marginLeft = "6px";
    item.appendChild( text);
    return item;
};